import React from 'react';
import { Card, Icon, Dropdown, Grid } from 'semantic-ui-react'
import Add from './add';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Buttons from '@material-ui/core/Button';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import $ from "jquery";
import Server from '../../functions/server';
import Remark from './remarks';

class Executiveticket extends React.Component {

  state = {
    statusdialog: false,
    fullWidth: true,
    maxWidth: 'xs',
  }

  handleClose = () => {
    this.setState({ statusdialog: false });
  };

  changeStatus = (name) => {
    let context = this;
    let id = this.state.statusId;
    let status = name;
    $.ajax({
      type: 'POST',
      data: { 'id': id, 'status': status },
      url: Server() + 'tickets/statusupdate.php',
      success: function(data)
      {
        if (data == 1) {
          context.setState({ statusdialog: false })
          let datas = context.props.data;
          datas.map((x) => {
            if (x.id == id) {
              x.status = status;
            }
          });
          context.props.update(datas);
        }
      },
      error: function(err)
      {
        console.log(err);
        context.setState({
          load: false,
        });
        alert('Try again!!!!')
      }
    });
  }

  update() {
    this.setState({ updateTicked: false })
  }

  render() {
    let i = 0;
    return (
      <div>
      <table width='100%' id="table">
        <tr>
          <th id="tableheader" style={{width: '5%'}}><center>Sino</center></th>
          <th id="tableheader" style={{width: '5%'}}><center>Ticket Id</center></th>
          <th id="tableheader" style={{width: '20%'}}><center>Title</center></th>
          <th id="tableheader" style={{width: '15%'}}><center>Executive</center></th>
          <th id="tableheader" style={{width: '15%'}}><center>Created By</center></th>
          <th id="tableheader" style={{width: '13%'}}><center>Created On</center></th>
          <th id="tableheader" style={{width: '7%'}}><center>Remark</center></th>
          <th id="tableheader" style={{width: '7%'}}><center>Status</center></th>
          <th id="tableheader" style={{width: '5%'}}><center>Edit</center></th>
        </tr>
        { this.props.data.map((x) => {
            if (this.props.userId == 6 || this.props.userId == 13) {
              if (this.props.status1 == 'All') {
                i++;
                return (
                  <tbody>
                  <tr>
                    <td><center>{i}</center></td>
                    <td><center>{x.id}</center></td>
                    <td><center>{x.title}</center></td>
                    <td><center>{x.assigned_to+"->"+x.executive_name}</center></td>
                    <td><center>{x.created_by+'->'+x.creator_name}</center></td>
                    <td><center>{x.timestamp}</center></td>
                    <td><center><Remark remark={x.content} /></center></td>
                    <td style={{cursor: 'pointer'}} onClick={ () => { this.setState({ statusdialog: true, statusId: x.id }) }}>
                      <center>
                        <u style={{color: '#4574A3'}}>{x.status}</u>
                      </center>
                    </td>
                    <td>
                      <center>
                        <Add update={this.update.bind(this)}  getTickets={this.props.getTickets}
                             data={this.props.data} id={x.id} type="edit" title="Update Ticket" />
                      </center>
                    </td>
                  </tr>
                  </tbody>
                )
              }
              else {
                if (this.props.status1 == x.status) {
                  i++;
                  return (
                    <tbody>
                    <tr>
                      <td><center>{i}</center></td>
                      <td><center>{x.id}</center></td>
                      <td><center>{x.title}</center></td>
                      <td><center>{x.assigned_to+"->"+x.executive_name}</center></td>
                      <td><center>{x.created_by+'->'+x.creator_name}</center></td>
                      <td><center>{x.timestamp}</center></td>
                      <td><center><Remark remark={x.content} /></center></td>
                      <td style={{cursor: 'pointer'}} onClick={ () => { this.setState({ statusdialog: true, statusId: x.id }) }}>
                        <center>
                          <u style={{color: '#4574A3'}}>{x.status}</u>
                        </center>
                      </td>
                      <td>
                        <center>
                          <Add update={this.update.bind(this)}  getTickets={this.props.getTickets}
                               data={this.props.data} id={x.id} type="edit" title="Update Ticket" />
                        </center>
                      </td>
                    </tr>
                    </tbody>
                  )
                }
              }
            }
            else {
              if (x.assigned_to == this.props.userId) {
                if (this.props.status1 == 'All') {
                  i++;
                  return (
                    <tbody>
                    <tr>
                      <td><center>{i}</center></td>
                      <td><center>{x.id}</center></td>
                      <td><center>{x.title}</center></td>
                      <td><center>{x.assigned_to+"->"+x.executive_name}</center></td>
                      <td><center>{x.created_by+'->'+x.creator_name}</center></td>
                      <td><center>{x.timestamp}</center></td>
                      <td><center><Remark remark={x.content} /></center></td>
                      <td style={{cursor: 'pointer'}} onClick={ () => { this.setState({ statusdialog: true, statusId: x.id }) }}>
                        <center>
                          <u style={{color: '#4574A3'}}>{x.status}</u>
                        </center>
                      </td>
                      <td>
                        <center>
                          <Add update={this.update.bind(this)}  getTickets={this.props.getTickets}
                               data={this.props.data} id={x.id} type="edit" title="Update Ticket" />
                        </center>
                      </td>
                    </tr>
                    </tbody>
                  )
                }
                else {
                  if (this.props.status1 == x.status) {
                    i++;
                    return (
                      <tbody>
                      <tr>
                        <td><center>{i}</center></td>
                        <td><center>{x.id}</center></td>
                        <td><center>{x.title}</center></td>
                        <td><center>{x.assigned_to+"->"+x.executive_name}</center></td>
                        <td><center>{x.created_by+'->'+x.creator_name}</center></td>
                        <td><center>{x.timestamp}</center></td>
                        <td><center><Remark remark={x.content} /></center></td>
                        <td style={{cursor: 'pointer'}} onClick={ () => { this.setState({ statusdialog: true, statusId: x.id }) }}>
                          <center>
                            <u style={{color: '#4574A3'}}>{x.status}</u>
                          </center>
                        </td>
                        <td>
                          <center>
                            <Add update={this.update.bind(this)}  getTickets={this.props.getTickets}
                                 data={this.props.data} id={x.id} type="edit" title="Update Ticket" />
                          </center>
                        </td>
                      </tr>
                      </tbody>
                    )
                  }
                }
              }
            }
          })
        }
      </table>

      <React.Fragment>
        <Dialog fullWidth={this.state.fullWidth} maxWidth={this.state.maxWidth}
          open={this.state.statusdialog} onClose={this.handleClose}
          aria-labelledby="max-width-dialog-title" >
          <DialogTitle id="max-width-dialog-title">Status</DialogTitle>
            <div style={{padding: '2%'}}>
              <List component="nav">
                <ListItem button>
                  <ListItemText primary="Pending"  onClick={this.changeStatus.bind(this, 'Pending')} />
                </ListItem>
                <ListItem button>
                  <ListItemText primary="Processing"  onClick={this.changeStatus.bind(this, 'Processing')} />
                </ListItem>
                <ListItem button>
                  <ListItemText primary="Closed"  onClick={this.changeStatus.bind(this, 'Closed')} />
                </ListItem>
              </List>
            </div>
          <DialogActions>
            <Buttons onClick={this.handleClose} color="primary">
              Close
            </Buttons>
          </DialogActions>
        </Dialog>
      </React.Fragment>
      </div>
    );
  }
}

export default Executiveticket;
